import { toast } from "sonner";

const THEME = "#215334";

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

/**
 * Opens Razorpay Standard Checkout for a server-created order.
 * `order` needs: razorpay_key_id, razorpay_order_id, total.
 */
export async function openRazorpayCheckout({ order, prefill, onSuccess, onFailure, onDismiss }) {
  const ok = await loadRazorpayScript();
  if (!ok) {
    toast.error("Razorpay could not load. Check your connection and try again.");
    return false;
  }
  const rzp = new window.Razorpay({
    key: order.razorpay_key_id,
    amount: Math.round(order.total * 100),
    currency: "INR",
    order_id: order.razorpay_order_id,
    name: "Immortal Vedas",
    description: "Natural Products Order",
    prefill,
    theme: { color: THEME },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  rzp.on("payment.failed", (resp) => onFailure?.(resp?.error?.description || "Payment failed. Please try another method."));
  rzp.open();
  return true;
}

/**
 * Opens Razorpay Checkout for the yoga membership. Handles both the recurring
 * subscription (subscription_id) and the one-time fallback (order_id) that the
 * backend returns when the Subscriptions add-on is not switched on.
 */
export async function openMembershipCheckout({ session, prefill, onSuccess, onFailure, onDismiss }) {
  const ok = await loadRazorpayScript();
  if (!ok) {
    toast.error("Razorpay could not load. Check your connection and try again.");
    return false;
  }
  const options = {
    key: session.key_id,
    name: "Immortal Vedas",
    description:
      session.mode === "subscription"
        ? `21-Day Yoga — ₹${session.amount} now, then ₹${session.monthly_amount}/month`
        : `21-Day Yoga — ₹${session.amount}`,
    prefill,
    theme: { color: THEME },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  };
  if (session.mode === "subscription") {
    options.subscription_id = session.subscription_id;
  } else {
    options.order_id = session.order_id;
    options.amount = Math.round(session.amount * 100);
    options.currency = session.currency || "INR";
  }
  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", (resp) => onFailure?.(resp?.error?.description || "Payment failed. Please try another method."));
  rzp.open();
  return true;
}
